import React, { Component } from "react";
import "./App.css";
import Persons from './components/persons/Persons/Persons';
import Home from './components/pages/Home/Home';
import NotFound from './components/common/NotFound/NotFound';
import AddPerson from './components/persons/AddPerson/AddPerson';
import UpdateDepartments from './components/departments/UpdateDepartments/UpdateDepartments';
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";
import Update from './components/persons/Update/Update';
import AddHoliday from './components/holidays/AddHoliday/AddHoliday';
import HolidaySegmentation from './components/holidays/HolidaySegmentation/HolidaySegmentation';
import PackageDistribution from './components/data/PackageDistribution/PackageDistribution';
import Login from './components/auth/Login/Login';
import Reister from './components/auth/Register/Register';
import Logout from './components/auth/Logout/Logout';
import UpdateCiti from './components/admin/UpdateCiti/UpdateCiti';
import Backup from './components/data/Backup/Backup';
// import GetTicket from './components/tickets/GetTicket/GetTicket';
// import Actions from './components/tickets/Actions/Actions';
// import ReactFullscreen from 'react-easyfullscreen';
import Open from './components/pages/Open/Open';
import Navbar from "./components/navbar/Navbar";
import Admin from "./components/pages/Admin/Admin";
import ExportData from "./components/pages/ExportData/ExportData";

// import VVV from './vvv';
class App extends Component {

  state = { OnePerson: undefined, fsw: null, user: null, manager: null, division: null, updateDepartments: null, general: null, Search: null, ShowSearch: false, Person: null }

  setUser = user => {
    const newState = {
      manager: null,
      user: null,
      division: null,
      updateDepartments: null,
      fsw: null,
      general: user
    };

    if (user) {
      const { role, nickname } = user;

      if (role === 'מנהלראשי') {
        newState.manager = user;
        newState.user = user;

        if (nickname === 'יוסי') {
          newState.fsw = user;
        } else {
          newState.division = user;
        }
      }

      if (role === 'מזכירות') {
        newState.user = user;
        newState.division = user;
      }

      if (role === 'חלוקת חבילות') {
        newState.division = user;
      }

      if (role === 'עדכון מחלקות') {
        newState.updateDepartments = user;
      }
    }

    this.setState(newState);
  };


  Newtime = () => {
    var today = new Date();
    var dd = checkTime(today.getDate());
    var mm = checkTime(today.getMonth() + 1)
    var yyyy = today.getFullYear();
    var h = today.getHours();
    var m = checkTime(today.getMinutes());
    function checkTime(i) { if (i < 10) { i = "0" + i; } return i; }
    var dateTime = dd + '/' + mm + '/' + yyyy + ' ' + h + ':' + m;
    return dateTime
  }

  // Person = (person) => {
  //   this.setState({ Person: person })
  // }

  find = (EditPerson, search) => {
    // console.log(search,"find app");
    this.setState({ OnePerson: EditPerson, Search: search })
  }
  ShowOldSearch = Bool => {
    // console.log(this.state.Search,"ShowOldSearch");
    // console.log(Bool,"Bool");
    this.setState({ ShowSearch: Bool })
  }

  componentDidMount() {
    let Token = sessionStorage.getItem('Token');
    let role = sessionStorage.getItem('role');
    let nickname = sessionStorage.getItem('nickname');
    let userId = sessionStorage.getItem('ID');

    if (Token && role && nickname && userId) {
      const user = { Token, role, nickname, userId };
      this.setUser(user);
    }
  }

  render() {

    return (
      <div className="App">
        <BrowserRouter>
          {this.state.general && <Navbar username={this.state.general.nickname} manager={this.state.manager} />}
          <div className={this.state.general ? "main-content" : ""}>
            <Switch>
              {/* <ReactFullscreen>
              {({ ref, onRequest, onExit }) => (
                <div
                  ref={ref}
                  style={{ width: 120, height: 120 }}
                >
                  <div className='Fullscreen'>
                    <button onClick={() => { onRequest(); this.setState({ buttons: false }); }}>FullScreen</button>
                    <button onClick={() => onExit()}>Screen</button>
                  </div>
                  <Route exact path='/GetTicket' render={() => <GetTicket setPerson={this.Person} />} />
                  <Route exact path='/Actions' render={() => <Actions Person={this.state.Person} setPerson={this.Person} />} />

                </div>
              )}
            </ReactFullscreen> */}
              <Route exact path='/Open' render={() => <Open />} />
              <Route exact path='/Home' render={() => <Home fsw={this.state.fsw} manager={this.state.manager} division={this.state.division} User={this.state.user} general={this.state.general} updateDepartments={this.state.updateDepartments} />} />
              <Route exact path='/Admin' render={() => <Admin User={this.state.user || this.state.updateDepartments} />} />
              {/* <Route exact path='/VVV' render={() => <VVV User={this.state.user}/>} /> */}
              <Route exact path='/Backup' render={() => <Backup User={this.state.user} />} />
              <Route exact path="/ExportToExcel" render={() => <ExportData />} />
              <Route exact path='/UpdateCiti' render={() => <UpdateCiti User={this.state.user} />} />
              <Route exact path='/HolidaySegmentation' render={() => <HolidaySegmentation User={this.state.user} />} />
              <Route exact path='/AddHoliday' render={() => <AddHoliday User={this.state.user} />} />
              <Route exact path='/Persons' render={() => <Persons find={this.find} ShowOldSearch={this.ShowOldSearch} User={this.state.user} Search={this.state.Search} ShowSearch={this.state.ShowSearch} />} />
              <Route exact path='/AddPerson' render={() => <AddPerson Newtime={this.Newtime} find={this.find} User={this.state.user} />} />
              <Route exact path='/UpdateDepartments' render={() => <UpdateDepartments User={this.state.user || this.state.updateDepartments} />} />
              <Route exact path='/Update' render={() => <Update User={this.state.user} ShowOldSearch={this.ShowOldSearch} OnePerson={this.state.OnePerson} />} />
              <Route exact path='/PackageDistribution' render={() => <PackageDistribution Newtime={this.Newtime} User={this.state.division} />} />
              <Route exact path='/' render={() => <Login setUser={this.setUser} />} />
              <Route exact path='/Reister' render={() => <Reister setUser={this.setUser} User={this.state.user} />} />
              <Route exact path='/Logout' render={() => <Logout setUser={this.setUser} />} />
              <Route component={NotFound} />
            </Switch>
          </div >
        </BrowserRouter>
      </div>
    );
  }
}

export default App;